import { render, staticRenderFns } from "./CusPictureUpload.vue?vue&type=template&id=3c47185c&scoped=true"
import script from "./CusPictureUpload.vue?vue&type=script&lang=ts"
export * from "./CusPictureUpload.vue?vue&type=script&lang=ts"
import style0 from "./CusPictureUpload.vue?vue&type=style&index=0&id=3c47185c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47185c",
  null
  
)

export default component.exports